<template>
  <div>
    <v-btn
      v-if="inline"
      icon
      @click="addNewRequestDialog = true"
      class="add-new-request-btn add-new-request-btn--inline"
      title="إضافة عميل"
    >
      <img src="@/assets/user-plus.svg" alt="user-plus" width="22" height="22" />
    </v-btn>
    <v-btn
      v-else
      fab
      top
      :color="$vuetify.theme.themes.light.dialogActionBTN"
      @click="addNewRequestDialog = true"
      class="my-10 add-new-request-btn"
      style="background-color: unset !important;"
    >
      <img src="@/assets/user-plus.svg" alt="user-plus" />
    </v-btn>
    <add-new-request
      v-model="addNewRequestDialog"
      width="350px"
      @submitted="get_all_requests"
    />
  </div>
</template>

<script>
import { axiosInstance } from "@/axios/config";
export default {
  name: "AddNewRequestBtn",

  props: {
    inline: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    addNewRequestDialog: false,
  }),
  methods: {
    async get_all_requests(page = 1) {
      this.loading = true;
      await axiosInstance
        .get(`/v2/employee/Requests?type=all&page=${page}&per_page=12`)
        .then((response) => {
          this.items = response.data.payload.data;
          this.pagination = {
            limit: 10,
            count: response.data.payload.count_of_all,
          };
          this.loading = false;
        });
    },
  },
};
</script>
